module.exports = __webpack_public_path__ + "img/whats-new-53-hero_9x16_poster.f1e9dae.jpg";